import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import uRLs from "../../utils/baseUtils";
import { useAuth } from "../../context/AuthProvider";
import { usePermission } from "../../context/PermissionContext";
import { AddIcon, AnalyseIcon, ArrowBackIcon, BarChartAlt2Icon, ChevronRightIcon, DollarCircleIcon, ExpenceIcon, FileEarmarkTextIcon, FileIcon, GroupIcon, HammerIcon, HomeIcon, IdCardIcon, MoneyIcon, NegobillIcon, NotepadIcon, ProductIcon, PurchaseTagIcon, ReceiptIcon, StockAddIcon, StockIcon, TimerIcon, TruckIcon, UndoIcon } from "../../constants/Icons";

function SideBar({ toggleSideMenu, onMenuClick }) {
  const [expandedMenu, setExpandedMenu] = useState(null);
  const { isUser } = useAuth();
  const {
    permission,
    hasModulePermission,
    hasPermission,
    activeStoreModules,
    blockedPermissions,
    viewOption,
  } = usePermission();
  const handleToggleMenu = (menuId) => {
    setExpandedMenu((prevMenu) => (prevMenu === menuId ? null : menuId));
  };
  const removeBackdropStyle = () => {
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.removeAttribute("style");
  };

  const handleLinkClick = () => {
    toggleSideMenu();
    removeBackdropStyle();
  };
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="wrapper toggled">
      <div
        className="overlay toggle-icon bc"
        onClick={() => {
          toggleSideMenu();
          removeBackdropStyle();
        }}
      ></div>
      <div>
        <div className="sidebar-wrapper" data-simplebar="true">
          <div className="sidebar-header">
            <div>
              <img
                src="/assets/images/logo-dark.png"
                className="logo-icon"
                alt="logo icon"
              />
            </div>
            <div
              className="toggle-icon ms-auto"
              onClick={() => {
                toggleSideMenu();
                removeBackdropStyle();
              }}
            >
              <ArrowBackIcon/>
            </div>
          </div>
          <ul className="metismenu" id="menu">
            <li
              className={`${currentPath === "/dashboard" ? "mm-active" : ""}`}
            >
              <Link
                to="/dashboard"
                onClick={handleLinkClick}
                className="active"
              >
                <div className="parent-icon">
                  <HomeIcon/>
                </div>
                <div className="menu-title">Dashboard</div>
              </Link>
            </li>
            {(hasModulePermission("CUSTOMER") || permission === undefined) && (
              <li
                className={`${currentPath === "/customer" ? "mm-active" : ""}`}
              >
                <Link
                  to="/customer"
                  onClick={() => {
                    handleLinkClick();
                    onMenuClick("/customer", "Customers");
                  }}
                >
                  <div className="parent-icon">
                    <GroupIcon/>
                  </div>
                  <div className="menu-title">Customers</div>
                </Link>
              </li>
              //   <li
              //   className={`${currentPath === "/customer" ? "mm-active" : ""}`}
              // >
              //   <div onClick={() => handleToggleMenu("customer")}>
              //     <Link
              //       to="#"
              //       className={`has-arrow ${
              //         expandedMenu === "customer" ? "mm-active" : ""
              //       }`}
              //       aria-expanded={expandedMenu === "customer"}
              //     >
              //       <div className="parent-icon">
              //         <i className="bx bx-group"></i>
              //       </div>
              //       <div className="menu-title">Customer</div>
              //     </Link>
              //   </div>
              //   {expandedMenu === "customer" && (
              //     <ul>

              //         <li>
              //           <Link to="/customer" onClick={handleLinkClick}>
              //             <ChevronRightIcon/>My Customer
              //           </Link>
              //         </li>
              //       {isUser.stype === "MAIN" && uRLs.ALL_CUSTOMER==="true" && (
              //         <li>
              //           <Link to="/allcustomer" onClick={handleLinkClick}>
              //             <ChevronRightIcon/>All Customer
              //           </Link>
              //         </li>)}
              //     </ul>
              //   )}
              // </li>
            )}

            {
              uRLs.SUPPLIER === "true" &&
                (hasModulePermission("SUPPLIER") ||
                  permission === undefined) && (
                  <li
                    className={`${
                      currentPath === "/supplier" ? "mm-active" : ""
                    }`}
                  >
                    <Link
                      to="/supplier"
                      onClick={() => {
                        handleLinkClick();
                        onMenuClick("/supplier", "Supplier");
                      }}
                    >
                      <div className="parent-icon">
                        <TruckIcon/>
                      </div>
                      <div className="menu-title">Supplier</div>
                    </Link>
                  </li>
                )
              //   <li
              //   className={`${currentPath === "/customer" ? "mm-active" : ""}`}
              // >
              //   <div onClick={() => handleToggleMenu("customer")}>
              //     <Link
              //       to="#"
              //       className={`has-arrow ${
              //         expandedMenu === "customer" ? "mm-active" : ""
              //       }`}
              //       aria-expanded={expandedMenu === "customer"}
              //     >
              //       <div className="parent-icon">
              //         <i className="bx bx-group"></i>
              //       </div>
              //       <div className="menu-title">Customer</div>
              //     </Link>
              //   </div>
              //   {expandedMenu === "customer" && (
              //     <ul>

              //         <li>
              //           <Link to="/customer" onClick={handleLinkClick}>
              //             <ChevronRightIcon/>My Customer
              //           </Link>
              //         </li>
              //       {isUser.stype === "MAIN" && uRLs.ALL_CUSTOMER==="true" && (
              //         <li>
              //           <Link to="/allcustomer" onClick={handleLinkClick}>
              //             <ChevronRightIcon/>All Customer
              //           </Link>
              //         </li>)}
              //     </ul>
              //   )}
              // </li>
            }

            {uRLs.PURCHASE === "true" &&
              activeStoreModules("PURCHASE") &&
              (hasModulePermission("PURCHASE") || permission === undefined) && (
                <li
                  className={`${
                    currentPath === "/listpurchase" ? "mm-active" : ""
                  }`}
                >
                  <Link
                    to="/listpurchase"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/listpurchase", "Purchase");
                    }}
                  >
                    <div className="parent-icon">
                      <PurchaseTagIcon/>
                    </div>
                    <div className="menu-title">Purchase</div>
                  </Link>
                </li>
              )}

            {(hasModulePermission("PRODUCT") || permission === undefined) && (
              <>
                {isUser.stype === "MAIN" &&
                  (hasPermission("PRODUCT", "PRODUCT:add") ||
                    permission === undefined) && (
                    <li
                      className={`${
                        currentPath === "/allproduct" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/allproduct"
                        onClick={() => {
                          handleLinkClick();
                          onMenuClick("/allproduct", "Product");
                        }}
                      >
                        <div className="parent-icon">
                          <ProductIcon iClass={"fs-6"}/>
                        </div>
                        <div className="menu-title">Product</div>
                      </Link>
                    </li>
                  )}
                {isUser.stype !== "MAIN" &&
                  (hasPermission("PRODUCT", "PRODUCT:list") ||
                    permission === undefined) && (
                    <li
                      className={`${
                        currentPath === "/listproduct" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/listproduct"
                        onClick={() => {
                          handleLinkClick();
                          onMenuClick("/listproduct", "List Product");
                        }}
                      >
                        <div className="parent-icon">
                        <ProductIcon iClass={"fs-6"}/>
                        </div>
                        <div className="menu-title">Product</div>
                      </Link>
                    </li>
                  )}
              </>
            )}

            {(hasModulePermission("STOCK") || permission === undefined) && (
              <li>
                <div onClick={() => handleToggleMenu("stocks")}>
                  <Link
                    to="#"
                    className={`has-arrow ${
                      expandedMenu === "stocks" ? "mm-active" : ""
                    }`}
                    aria-expanded={expandedMenu === "stocks"}
                  >
                    <div className="parent-icon">
                      <StockIcon/>
                    </div>
                    <div className="menu-title">Stock</div>
                  </Link>
                </div>
                {expandedMenu === "stocks" && (
                  <ul>
                    {isUser.stype === "MAIN" &&
                      (blockedPermissions("STOCK:add") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/stock"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/stock", "Stock");
                            }}
                          >
                            <StockAddIcon/>Add Stock
                          </Link>
                        </li>
                      )}
                    {isUser.stype === "MAIN" &&
                      (blockedPermissions("STOCK:list") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/liststock"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/liststock", "List Stock");
                            }}
                          >
                            <ChevronRightIcon/>List Stock
                          </Link>
                        </li>
                      )}
                    {uRLs.SUB_STOCK === "true" &&
                      (isUser?.stype === "SUB" || isUser?.stype === "HUB") &&
                      (blockedPermissions("STOCK:addDirect") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/substock"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/substock", "Direct Stock");
                            }}
                          >
                            <StockAddIcon/>Add
                            Direct Stock
                          </Link>
                        </li>
                      )}
                    {/* {uRLs.SUB_STOCK === "true" &&
                      (isUser?.stype === "SUB" || isUser?.stype === "HUB") &&
                      (blockedPermissions("STOCK:addDirect") ||
                        permission === undefined) && (
                        <li>
                          <Link to="/listsubStock" onClick={handleLinkClick}>
                            <ChevronRightIcon/>List Stock
                          </Link>
                        </li>
                      )} */}
                    {(hasPermission("STOCK", "STOCK:listAvailable") ||
                      permission === undefined) && (
                      <li>
                        <Link
                          to="/stockavailable"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/stockavailable", "Stock Available");
                          }}
                        >
                          <ChevronRightIcon/>Stock Available
                        </Link>
                      </li>
                    )}
                    {uRLs.STOCK_TRANSFER === "true" &&
                      activeStoreModules("STOCKTRANSFER") &&
                      (hasModulePermission("STOCKTRANSFER") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/liststocktransfer"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick(
                                "/liststocktransfer",
                                "Stock Transfer",
                              );
                            }}
                          >
                            <ChevronRightIcon/>Stock
                            Transfer
                          </Link>
                        </li>
                      )}
                    {uRLs.STOCK_ARRIVAL === "true" &&
                      activeStoreModules("STOCKTRANSFER") &&
                      (hasModulePermission("STOCKTRANSFER") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/stockarrival"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/stockarrival", "Stock Arrival");
                            }}
                          >
                            <ChevronRightIcon/>Stock Arrival
                          </Link>
                        </li>
                      )}
                    {uRLs.STOCK_TRASH === "true" &&
                      isUser.stype === "MAIN" &&
                      (hasPermission("STOCK", "STOCK:getTrash") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/stocktrash"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/stocktrash", "Stock Trash");
                            }}
                          >
                            <ChevronRightIcon/>Stock Trash
                          </Link>
                        </li>
                      )}
                    {(hasPermission("REPORT", "REPORT:getSale") ||
                      permission === undefined) && (
                      <li>
                        <Link
                          to="/stock-report"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/stock-report", "Stock Report");
                          }}
                        >
                          <ChevronRightIcon/>Stock Report
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {/* {isUser.stype === "MAIN" &&
              (hasModulePermission("PRODUCT") || permission === undefined) && (
                <li
                  className={`${currentPath === "/product" ? "mm-active" : ""}`}
                >
                  <div onClick={() => handleToggleMenu("product")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "product" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "product"}
                    >
                      <div className="parent-icon">
                        <i className="bx bx-barcode-reader"></i>
                      </div>
                      <div className="menu-title">Products</div>
                    </Link>
                  </div>
                  {expandedMenu === "product" && (
                    <ul>
                      {(hasPermission("PRODUCT", "PRODUCT:add") ||
                        permission === undefined) && (
                        <li>
                          <Link to="/product" onClick={handleLinkClick}>
                            <i className="ng ng-ng-add-icon"></i>Add Product
                          </Link>
                        </li>
                      )}
                      {(hasPermission("PRODUCT", "PRODUCT:list") ||
                        permission === undefined) && (
                        <li>
                          <Link to="/listproduct" onClick={handleLinkClick}>
                            <ChevronRightIcon/>List Product
                          </Link>
                        </li>
                      )}
                      {isUser.stype === "MAIN" &&  uRLs.ALL_PRODUCT==="true" &&(
                        <li>
                          <Link to="/allproduct" onClick={handleLinkClick}>
                            <ChevronRightIcon/>All Product
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )} */}

            {uRLs.SERVICE === "true" &&
              (hasModulePermission("SERVICE") || permission === undefined) && (
                <li
                  className={`${
                    currentPath === "/listservice" ? "mm-active" : ""
                  }`}
                >
                  <Link
                    to="/listservice"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/listservice", "Service");
                    }}
                  >
                    <div className="parent-icon">
                      <NotepadIcon/>
                    </div>
                    <div className="menu-title">Service</div>
                  </Link>
                </li>
                // <li>
                //   <div onClick={() => handleToggleMenu("service")}>
                //     <Link
                //       to="#"
                //       className={`has-arrow ${
                //         expandedMenu === "service" ? "mm-active" : ""
                //       }`}
                //       aria-expanded={expandedMenu === "service"}
                //     >
                //       <div className="parent-icon">
                //         <i className="bx bx-notepad"></i>
                //       </div>
                //       <div className="menu-title">Service</div>
                //     </Link>
                //   </div>
                //   {expandedMenu === "service" && (
                //     <ul>
                //       <li>
                //         <Link to="/listservice" onClick={handleLinkClick}>
                //           <ChevronRightIcon/>List Service
                //         </Link>
                //       </li>
                //     </ul>
                //   )}
                // </li>
              )}

            {uRLs.RECHARGE_MODULE === "true" &&
              (hasModulePermission("RECHARGE") || permission === undefined) &&
              activeStoreModules("RECHARGE") && (
                <li
                  className={`${
                    currentPath === "/recharge" ? "mm-active" : ""
                  }`}
                >
                  <Link
                    to="/recharge"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/recharge", "Recharge");
                    }}
                  >
                    <div className="parent-icon">
                      <DollarCircleIcon/>
                    </div>
                    <div className="menu-title">Recharge</div>
                  </Link>
                </li>
              )}

            {/* {uRLs.PRE_SALE === "true" && (
              <li
                className={`${
                  currentPath === "/listpresale" ? "mm-active" : ""
                }`}
              >
                <Link
                  to="/listpresale"
                  onClick={() => {
                    handleLinkClick();
                    onMenuClick("/listpresale", "ListPreSale");
                  }}
                >
                  <div className="parent-icon">
                    <i className="bi bi-file-earmark-text"></i>
                  </div>
                  <div className="menu-title">PreSale</div>
                </Link>
              </li>
            )} */}

            {uRLs.PRE_SALE === "true" &&
              activeStoreModules("PRESALE") &&
              (hasModulePermission("PRESALE") || permission === undefined) && (
                <li>
                  <div onClick={() => handleToggleMenu("ListPreSale")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "ListPreSale" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "ListPreSale"}
                    >
                      <div className="parent-icon">
                        <FileEarmarkTextIcon/>
                      </div>
                      <div className="menu-title">Pre Sale</div>
                    </Link>
                  </div>
                  {expandedMenu === "ListPreSale" && (
                    <ul>
                      <li>
                        <Link
                          to="/listpresale"
                          state={{ mode: "proforma" }}
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/listpresale", "Pre Sale");
                          }}
                        >
                          <div className="parent-icon">
                            <ReceiptIcon/>
                          </div>
                          <div className="menu-title">Proforma</div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/listpresale"
                          state={{ mode: "estimation" }}
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/listpresale", "Pre Sale");
                          }}
                        >
                          <div className="parent-icon">
                            <i className="bi-calculator"></i>
                          </div>
                          <div className="menu-title">Estimation</div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/listpresale"
                          state={{ mode: "quotation" }}
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/listpresale", "Pre Sale");
                          }}
                        >
                          <div className="parent-icon">
                            <NotepadIcon/>
                          </div>
                          <div className="menu-title">Quotation</div>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              )}

            {/* {uRLs.PURCHASE === "true" &&
              (hasModulePermission("PORFORMA") || permission === undefined) && (
                <li
                  className={`${
                    currentPath === "/Proforma" ? "mm-active" : ""
                  }`}
                >
                  <Link
                    to="/Proforma"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/Proforma", "Proforma");
                    }}
                  >
                    <div className="parent-icon">
                      <i className="bi-cart-check"></i>
                    </div>
                    <div className="menu-title">Porforma</div>
                  </Link>
                </li>
              )} */}

            {/* {uRLs.PURCHASE === "true" &&
              (hasModulePermission("PURCHASE") || permission === undefined) && (
                <li>
                  <div onClick={() => handleToggleMenu("purchase")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "purchase" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "purchase"}
                    >
                      <div className="parent-icon">
                        <i className="bx bxs-purchase-tag"></i>
                      </div>
                      <div className="menu-title">Purchase</div>
                    </Link>
                  </div>
                  {expandedMenu === "purchase" && (
                    <ul>
                      <li>
                        <Link
                          to="/purchase"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/purchase", "Purchase");
                          }}
                        >
                          <i className="ng ng-ng-add-icon"></i>Add Purchase
                        </Link>
                      </li>

                      <li>
                        <Link to="/listpurchase" onClick={handleLinkClick}>
                          <ChevronRightIcon/>List Purchase
                        </Link>
                      </li>

                      {/* {(hasPermission("REPORT", "REPORT:getSale") ||
                    permission === undefined) && (
                    <li>
                      <Link to="/sales-report" onClick={handleLinkClick}>
                        <ChevronRightIcon/>Sale Report
                      </Link>
                    </li>
                  )} 
                    </ul>
                  )}
                </li>
              )} */}

            {(hasModulePermission("SALE") || permission === undefined) && (
              <li>
                <div onClick={() => handleToggleMenu("sales")}>
                  <Link
                    to="#"
                    className={`has-arrow ${
                      expandedMenu === "sales" ? "mm-active" : ""
                    }`}
                    aria-expanded={expandedMenu === "sales"}
                  >
                    <div className="parent-icon">
                      <NegobillIcon/>
                    </div>
                    <div className="menu-title">Sales</div>
                  </Link>
                </div>
                {expandedMenu === "sales" && (
                  <ul>
                    {(blockedPermissions("SALE:add") ||
                      permission === undefined) && (
                      <li>
                        <Link
                          to="/sale"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/sale", "Sales");
                          }}
                        >
                          <AddIcon/>Add Sale
                        </Link>
                      </li>
                    )}
                    {(blockedPermissions("SALE:list") ||
                      permission === undefined) && (
                      <li>
                        <Link
                          to="/listsale"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/listsale", "List Sale");
                          }}
                        >
                          <ChevronRightIcon/>List Sale
                        </Link>
                      </li>
                    )}

                    {blockedPermissions("SALE:listByStaff") &&
                      permission !== undefined && (
                        <li>
                          <Link
                            to="/stafflistsale"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/stafflistsale", "List Staff Sale");
                            }}
                          >
                            <ChevronRightIcon/>
                            List Staff Sale
                          </Link>
                        </li>
                      )}

                    {(hasPermission("REPORT", "REPORT:getSale") ||
                      permission === undefined) && (
                      <li>
                        <Link
                          to="/sales-report"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/sales-report", "Sale Report");
                          }}
                        >
                          <ChevronRightIcon/>Sale Report
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {uRLs.RETURN_SALE === "true" &&
              (hasModulePermission("SALERETURN") ||
                permission === undefined) && (
                // activeStoreModules("SALERETURN") &&
                <li
                  className={`${
                    currentPath === "/listreturnsale" ? "mm-active" : ""
                  }`}
                >
                  <Link
                    to="/listreturnsale"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/listreturnsale", "Return Sale");
                    }}
                  >
                    <div className="parent-icon">
                      <UndoIcon/>
                    </div>
                    <div className="menu-title">Return Sale</div>
                  </Link>
                </li>
              )}

            {/* <li className={`${currentPath === "/stock" ? "mm-active" : ""}`}>
              <div onClick={() => handleToggleMenu("stock")}>
                <Link
                  to="#"
                  className={`has-arrow ${
                    expandedMenu === "stock" ? "mm-active" : ""
                  }`}
                  aria-expanded={expandedMenu === "stock"}
                >
                  <div className="parent-icon">
                    <i className="bx bx-package"></i>
                  </div>
                  <div className="menu-title">Stock Batch</div>
                </Link>
              </div>
              {expandedMenu === "stock" && (
                <ul>
                  <li>
                    <Link to="/stock" onClick={handleLinkClick}>
                      <ChevronRightIcon/>Add Stock Batch
                    </Link>
                  </li>
                  <li>
                    <Link to="/liststock" onClick={handleLinkClick}>
                      <ChevronRightIcon/>List Stock Batch
                    </Link>
                  </li>
                </ul>
              )}
            </li> */}
            {/* <li
              className={`${
                currentPath === "/stocktransfer" ? "mm-active" : ""
              }`}
            >
              <div onClick={() => handleToggleMenu("stocktransfer")}>
                <Link
                  to="#"
                  className={`has-arrow ${
                    expandedMenu === "stocktransfer" ? "mm-active" : ""
                  }`}
                  aria-expanded={expandedMenu === "stocktransfer"}
                >
                  <div className="parent-icon">
                    <i className="bx bx-transfer"></i>
                  </div>
                  <div className="menu-title">Stock Transfer</div>
                </Link>
              </div>
              {expandedMenu === "stocktransfer" && (
                <ul>
                  <li>
                    <Link to="/stocktransfer" onClick={handleLinkClick}>
                      <ChevronRightIcon/>Add Transfer
                    </Link>
                  </li>
                  <li>
                    <Link to="/liststocktransfer" onClick={handleLinkClick}>
                      <ChevronRightIcon/>List Transfer
                    </Link>
                  </li>
                </ul>
              )}
            </li> */}
            {/* {uRLs.ESTIMATE_MODULE === "true" &&
              activeStoreModules("ESTIMATE") &&
              (hasModulePermission("ESTIMATE") || permission === undefined) && (blockedPermissions("ESTIMATE:list") ||
              permission === undefined) && (
              <li
                className={`${currentPath === "listestimation" ? "mm-active" : ""}`}
              >
                <Link to="listestimation" onClick={handleLinkClick}>
                  <div className="parent-icon">
                    <i className="bx bx-notepad"></i>
                  </div>
                  <div className="menu-title">Estimation</div>
                </Link>
              </li>
            )} */}

            {uRLs.JOBCARD === "true" &&
              activeStoreModules("JOBCARD") &&
              (hasModulePermission("JOBCARD") || permission === undefined) && (
                <li
                  className={`${currentPath === "/jobcard" ? "mm-active" : ""}`}
                >
                  <Link
                    to="/listjobcard"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/listjobcard", "JobCard");
                    }}
                  >
                    <div className="parent-icon">
                      <IdCardIcon/>
                    </div>
                    <div className="menu-title">JobCard</div>
                  </Link>
                </li>
              )}
            {uRLs.PROJECT === "true" &&
              activeStoreModules("PROJECT") &&
              (hasModulePermission("PROJECT") || permission === undefined) && (
                <li
                  className={`${currentPath === "/project" ? "mm-active" : ""}`}
                >
                  <Link
                    to="/listProject"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/listProject", "Project");
                    }}
                  >
                    <div className="parent-icon">
                      <HammerIcon/>
                    </div>
                    <div className="menu-title">Project</div>
                  </Link>
                </li>
              )}

            {uRLs.ESTIMATE_MODULE === "true" &&
              activeStoreModules("ESTIMATE") &&
              permission === undefined && (
                <li
                  className={`${
                    currentPath === "/listestimation" ? "mm-active" : ""
                  }`}
                >
                  <Link
                    to="/listestimation"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/listestimation", "Estimate");
                    }}
                  >
                    <div className="parent-icon">
                      <NotepadIcon/>
                    </div>
                    <div className="menu-title">Estimate</div>
                  </Link>
                </li>
              )}
            {uRLs.ESTIMATE_MODULE === "true" &&
              activeStoreModules("ESTIMATE") &&
              hasModulePermission("ESTIMATE") && (
                <li>
                  <div onClick={() => handleToggleMenu("estimation")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "estimation" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "estimation"}
                    >
                      <div className="parent-icon">
                        <NotepadIcon/>
                      </div>
                      <div className="menu-title">Estimation</div>
                    </Link>
                  </div>
                  {expandedMenu === "estimation" && (
                    <ul>
                      {(blockedPermissions("ESTIMATE:list") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/listestimation"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/listestimation", "Estimate");
                            }}
                          >
                            <ChevronRightIcon/>List
                            Estimation
                          </Link>
                        </li>
                      )}
                      {permission !== undefined && (
                        <li>
                          <Link
                            to="/mylist"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/mylist", "My List");
                            }}
                          >
                            <ChevronRightIcon/>My List
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )}
            {uRLs.EXPENSE_MODULE === "true" &&
              (hasModulePermission("EXPENSE") || permission === undefined) && (
                <li
                  className={`${currentPath === "/expense" ? "mm-active" : ""}`}
                >
                  <div onClick={() => handleToggleMenu("expense")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "expense" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "expense"}
                    >
                      <div className="parent-icon">
                        <ExpenceIcon/>
                      </div>
                      <div className="menu-title">Expense</div>
                    </Link>
                  </div>
                  {expandedMenu === "expense" && (
                    <ul>
                      {(hasPermission("EXPENSE", "EXPENSE:add") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/expense"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/expense", "Expense");
                            }}
                          >
                            <ChevronRightIcon/>Add Expense
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link
                          to="/expanse-report"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/expanse-report", "Expense Report");
                          }}
                        >
                          <ChevronRightIcon/>Expense Report
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              )}
            {(hasModulePermission("BOXCASH") || permission === undefined) && (
              <li
                className={`${currentPath === "/boxcash" ? "mm-active" : ""}`}
              >
                <Link
                  to="/boxcash"
                  onClick={() => {
                    handleLinkClick();
                    onMenuClick("/boxcash", "BoxCash");
                  }}
                >
                  <div className="parent-icon">
                    <MoneyIcon/>
                  </div>
                  <div className="menu-title">Boxcash</div>
                </Link>
              </li>
            )}

            {(hasModulePermission("PAYLATER") || permission === undefined) && (
              <li
                className={`${currentPath === "/paylater" ? "mm-active" : ""}`}
              >
                <Link
                  to="/paylater"
                  onClick={() => {
                    handleLinkClick();
                    onMenuClick("/paylater", "Pay Later");
                  }}
                >
                  <div className="parent-icon">
                    <TimerIcon/>
                  </div>
                  <div className="menu-title">Pay Later</div>
                </Link>
              </li>
            )}
            {uRLs.REPORTS_MODULE === "true" &&
              (hasModulePermission("REPORT") || permission === undefined) && (
                <li>
                  <div onClick={() => handleToggleMenu("report")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "report" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "report"}
                    >
                      <div className="parent-icon">
                        <BarChartAlt2Icon/>
                      </div>
                      <div className="menu-title">Reports</div>
                    </Link>
                  </div>
                  {expandedMenu === "report" && (
                    <ul>
                      {(blockedPermissions("REPORT:getSale") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/sales-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/sales-report", "Sale Report");
                            }}
                          >
                            <ChevronRightIcon/>Sale Report
                          </Link>
                        </li>
                      )}
                      {(blockedPermissions("REPORT:getStock") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/stock-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/stock-report", "Stock Report");
                            }}
                          >
                            <ChevronRightIcon/>Stock Report
                          </Link>
                        </li>
                      )}
                      {viewOption("reportSettings", "isServiceDoneByReport") &&
                        (blockedPermissions("REPORT:getServiceDoneBy") ||
                          permission === undefined) && (
                          <li>
                            <Link
                              to="/service-doneby-report"
                              onClick={() => {
                                handleLinkClick();
                                onMenuClick(
                                  "/service-doneby-report",
                                  "Service Done By Report",
                                );
                              }}
                            >
                              <ChevronRightIcon/>Service
                              Done By
                            </Link>
                          </li>
                        )}
                      {(blockedPermissions("REPORT:getGstr1") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/gstr1-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/gstr1-report", "GSTR1-Report");
                            }}
                          >
                            <ChevronRightIcon/>GSTR1 Report
                          </Link>
                        </li>
                      )}
                      {(blockedPermissions("REPORT:getHsn") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/hsn-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/hsn-report", "HSN-Report");
                            }}
                          >
                            <ChevronRightIcon/>HSN Report
                          </Link>
                        </li>
                      )}
                      {(blockedPermissions(
                        "REPORT:getSaleProductByProductId",
                      ) ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/product-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/product-report", "Product-Report");
                            }}
                          >
                            <ChevronRightIcon/>Product
                            Report
                          </Link>
                        </li>
                      )}
                      {(blockedPermissions("EXPENSE:viewReport") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/expanse-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick("/expanse-report", "Expanse-Report");
                            }}
                          >
                            <ChevronRightIcon/>Expense
                            Report
                          </Link>
                        </li>
                      )}
                      {(blockedPermissions("REPORT:getProfitLoss") ||
                        permission === undefined) && (
                        <li>
                          <Link
                            to="/profitloss-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick(
                                "/profitloss-report",
                                "profit Loss-report",
                              );
                            }}
                          >
                            <ChevronRightIcon/>Profit And
                            Loss
                          </Link>
                        </li>
                      )}
                      {uRLs.RETURN_SALE === "true" && (
                        <li>
                          <Link
                            to="/saleretrun-report"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick(
                                "/saleretrun-report",
                                "Sale Return Report",
                              );
                            }}
                          >
                            <ChevronRightIcon/>Return Sale
                          </Link>
                        </li>
                      )}
                      {
                        <li>
                          <Link
                            to="/sale-transactions"
                            onClick={() => {
                              handleLinkClick();
                              onMenuClick(
                                "/sale-transactions",
                                "Sale Transactions",
                              );
                            }}
                          >
                            <ChevronRightIcon/>Sale
                            Transactions
                          </Link>
                        </li>
                      }
                    </ul>
                  )}
                </li>
              )}
            {uRLs.ANALYTICS === "true" &&
              activeStoreModules("ANALYTICS") &&
              (hasModulePermission("ANALYTICS") ||
                permission === undefined) && (
                <li>
                  <div onClick={() => handleToggleMenu("analytics")}>
                    <Link
                      to="#"
                      className={`has-arrow ${
                        expandedMenu === "analytics" ? "mm-active" : ""
                      }`}
                      aria-expanded={expandedMenu === "analytics"}
                    >
                      <div className="parent-icon">
                        <AnalyseIcon/>
                      </div>
                      <div className="menu-title">Analytics</div>
                    </Link>
                  </div>
                  {expandedMenu === "analytics" && (
                    <ul>
                      <li>
                        <Link
                          to="/analytics"
                          onClick={() => {
                            handleLinkClick();
                            onMenuClick("/analytics", "Analytics");
                          }}
                        >
                          <ChevronRightIcon/>Sales
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              )}
            {uRLs.VOUCHER === "true" &&
              (hasModulePermission("VOUCHER") || permission === undefined) && (
                <li
                  className={`${currentPath === "/voucher" ? "mm-active" : ""}`}
                >
                  <Link
                    to="/voucher"
                    onClick={() => {
                      handleLinkClick();
                      onMenuClick("/voucher", "Voucher");
                    }}
                  >
                    <div className="parent-icon">
                      <FileIcon/>
                    </div>
                    <div className="menu-title">Voucher</div>
                  </Link>
                </li>
              )}
            {/* <li className={`${currentPath === "/settings" ? "mm-active" : ""}`}>
              <Link to="/setting" onClick={handleLinkClick}>
                <div className="parent-icon">
                  <i className="bx bx-cog"></i>
                </div>
                <div className="menu-title">Settings</div>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
